module.exports = {
  text: `Перед тем как открыть саркофаг — зажги факел`,
  author: `седьмое правило выживания в подземельях Мистика X`,
}
